module.exports = __webpack_public_path__ + "static/logo1-063d87e05362fbbfadaf550e06c56bd9.png";